import Vue from 'vue'
import Router from 'vue-router'
import { turtasRoute } from './configTurtas'
import { savitarnaRoute } from './configSavitarna'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import { authRoute } from './routeRole'

store.dispatch('setAppHost', window.location.host)
const appSavitarna = store.getters.appSavitarna

const routes = appSavitarna ? savitarnaRoute : turtasRoute

Vue.use(Router)
const router = new Router({
  base: '/',
  // base: process.env.VUE_APP_NTRPASLAUGOS ? '/ntrpaslaugos' : '/',
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes,
})

// router gards
if (appSavitarna) {
  router.beforeEach((to, from, next) => {
    NProgress.start()

    next()
    // if (to.query.xid) {
    //   next()
    // } else {
    //   if (from.query.xid) {
    //     to.query.xid = from.query.xid
    //     to.query.enc = from.query.enc
    //     next(to)
    //   } else {
    //     next()
    //   }
    // }
  })
}

if (!appSavitarna) {
  router.beforeEach((to, from, next) => {
    NProgress.start()
    const token = store.getters.getAccessToken
    const sutikimas = store.getters.userSutikimas

    if (to.meta.open) {
      next()
      return
    }
    if (!token) {
      next({ name: 'login' })
      return
    }
    if (!sutikimas) {
      next({ name: 'sutikimas' })
      return
    }

    if (!authRoute(to.name)) {
      next({ name: 'home' })
      return
    }

    next()
  })
}

router.afterEach(() => {
  NProgress.done()
})

const { isNavigationFailure, NavigationFailureType } = Router
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    NProgress.done()
    if (
      !isNavigationFailure(err, NavigationFailureType.aborted) &&
      !isNavigationFailure(err, NavigationFailureType.canceled) &&
      !isNavigationFailure(err, NavigationFailureType.duplicated)
    )
      throw err
  })
}

export default router
